import { GuidedGame } from '../types';

/**
 * First-game teaching paths — separate for 4 / 3 / 2 players.
 * Stable step IDs must not change (progress persistence).
 */
export const laFamigliaGuidedGame: GuidedGame = {
  steps: [
    // ——— 4 players (2vs2) ———
    {
      id: 'guided-4-1',
      title: 'Krok 1 — cel i drużyny',
      summary:
        'Pokaż Mandamenti na planszy i wyjaśnij, że wygrywa drużyna: 5 Mandamenti u jednego partnera albo 6 łącznie. Partnerzy siedzą obok siebie i wygrywają wspólnie, ale każdy prowadzi własną rodzinę.',
      checklist: [
        'Wskaż kilka Mandamenti (po trzy obszary w tym samym kolorze tła).',
        'Wyjaśnij próg 5 (jeden gracz) / 6 (drużyna łącznie).',
        'Upewnij się, że partnerzy siedzą obok siebie, a kolejność tur wynika ze strzałek narożników.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Bez wspólnego celu nowi gracze grają „każdy na siebie” i źle liczą zwycięstwo. Kolor Mandamento nie jest kolorem rodziny — to tylko identyfikacja regionu.',
      commonMistake:
        'Liczenie zwycięstwa indywidualnie albo traktowanie koloru Mandamento jako koloru gracza.',
      sectionId: 'goal',
      players: [4],
    },
    {
      id: 'guided-4-2',
      title: 'Krok 2 — siedziba i komunikacja',
      summary:
        'Pokaż ekran siedziby: pieniądze, Soldati i rozkazy są tajne dla przeciwnej drużyny, ale partner może je oglądać. Partnerzy mogą omawiać plany; szczegółów zakrytego rozkazu nie ujawniajcie przy przeciwnikach.',
      checklist: [
        'Pokaż, co leży za ekranem (siedziba), a co w zapasie przed ekranem.',
        'Powiedz, że partner może zajrzeć do siedziby sojusznika.',
        'Ustalcie: plany wolno omawiać, ale nie odczytujcie głośno nadruku zakrytego rozkazu przy stole przeciwników.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Cała gra opiera się na ukrytym zamiarze. Jeśli przeciwnicy znają rozkaz zanim zostanie ujawniony, znika sens fazy planowania. Siedziba to nie zapas — pomylenie tych miejsc psuje rekrutację i wystawianie.',
      commonMistake:
        'Traktowanie siedziby jak wspólnego stosu drużyny albo głośne omawianie nadruku rozkazu przy przeciwnikach.',
      sectionId: 'teams-communication',
      players: [4],
    },
    {
      id: 'guided-4-3',
      title: 'Krok 3 — plansza rodziny',
      summary:
        'Pokaż cztery instytucje i wyjaśnij, że wpływy zdejmuje się od lewej do prawej. Odsłonięcie lewego pola nowej kolumny daje zaawansowany rozkaz do siedziby.',
      checklist: [
        'Wskaż wiersze: Sprawiedliwość, Policja, Gospodarka, Kościół.',
        'Pokaż kierunek zdejmowania wpływów (lewa → prawa).',
        'Wskaż miejsce zaawansowanych rozkazów A/B/C na planszy rodziny.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Wartości ataku, wystawiania, dochodu i rekrutacji bierze się z najbardziej prawej odsłoniętej liczby. Błędne zdejmowanie blokuje rozwój i psuje ekonomię całej rundy.',
      commonMistake:
        'Zdejmowanie wpływów od prawej albo branie zaawansowanego rozkazu bez odsłonięcia lewego pola kolumny.',
      sectionId: 'family-mat',
      players: [4],
    },
    {
      id: 'guided-4-4',
      title: 'Krok 4 — pierwsza tura planowania',
      summary:
        'Przećwiczcie jedną pełną turę: wybór wpływu (własny / neutralny / cudzy), ewentualna zapłata 1 właścicielowi, przeniesienie na pole akcji albo kolumnę, wykonanie akcji.',
      checklist: [
        'Wykonajcie opcję A (jeden wpływ → pole akcji) albo B (cała kolumna).',
        'Przy cudzym wpływie zapłaćcie 1 właścicielowi przed przeniesieniem.',
        'Rozliczcie koszt/przychód pola i wykonajcie co najmniej jedną legalną część akcji.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Planowanie to silnik gry. Symbol „/” to wybór jednej części, „+” pozwala wykonać obie. Nie wolno wybrać pola i zrezygnować ze wszystkich skutków.',
      commonMistake:
        'Używanie cudzego wpływu bez zapłaty albo wybór pola i pominięcie całej akcji.',
      sectionId: 'planning',
      players: [4],
    },
    {
      id: 'guided-4-5',
      title: 'Krok 5 — pierwszy rozkaz',
      summary:
        'Każdy połóż zakryty rozkaz w obszarze z własnym Soldato. Rozkaz pochodzi z siedziby; na mapie nie może leżeć drugi, chyba że zdolność na to pozwala.',
      checklist: [
        'Sprawdźcie własnego Soldato w obszarze docelowym.',
        'Weźcie żeton z siedziby i połóżcie go zakryty.',
        'Nie omawiajcie nadruku przy przeciwnej drużynie.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Rozkaz to obietnica na fazę starcia. Bez własnego Soldato w obszarze zwykle nie da się go wykonać — żeton schodzi bez nielegalnego efektu.',
      commonMistake:
        'Kładzenie rozkazu w obszarze partnera albo ujawnianie go przed starciem.',
      sectionId: 'planning-actions',
      players: [4],
    },
    {
      id: 'guided-4-6',
      title: 'Krok 6 — zarządzanie po planowaniu',
      summary:
        'Po opróżnieniu górnego arkusza zaktualizujcie kompletne Mandamenti i przyznajcie kafle kontroli. Nie zaczynajcie jeszcze konfliktów.',
      checklist: [
        'Sprawdźcie, kto kontroluje wszystkie trzy obszary każdego Mandamento.',
        'Przyznajcie lub zaktualizujcie kafle kontroli drużyny.',
        'Dopiero potem przejdźcie do ujawniania rozkazów w starciu.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Kontrola i kafle to efekt zarządzania, nie „przy okazji” walki. Mylenie kolejności faz psuje premie i warunek zwycięstwa.',
      commonMistake:
        'Rozpoczynanie ataków przed zarządzaniem po planowaniu.',
      sectionId: 'ultima-azione',
      players: [4],
    },
    {
      id: 'guided-4-7',
      title: 'Krok 7 — zaopatrzenie przed atakami',
      summary:
        'W starciu najpierw wykonajcie rozkazy zaopatrzenia według inicjatywy, dopiero potem ruch i ataki. Zaopatrzenie wzmacnia pozycję, zwykle bez konfliktu kart.',
      checklist: [
        'Ułóżcie ujawnione rozkazy według inicjatywy z żetonów i planszy starcia.',
        'Wykonajcie sekcje zaopatrzenia przed sekcjami ataku.',
        'Sprawdźcie, czy symbole wykonujecie w legalnym zakresie (niemożliwe pomińcie).',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Kolejność inicjatywy i typów rozkazów to kościec starcia. Atak przed zaopatrzeniem zmienia siły na mapie w sposób niedozwolony.',
      commonMistake:
        'Wykonywanie ataków przed zaopatrzeniem „bo wygodniej”.',
      sectionId: 'supply-orders',
      players: [4],
    },
    {
      id: 'guided-4-8',
      title: 'Krok 8 — pierwszy atak i konflikt',
      summary:
        'Przećwiczcie pełną procedurę: deklaracja ruchu i samochodu, premie, tajny wybór kart konfliktu, ujawnienie, specjalne efekty, straty, kontrola, ewentualne usunięcie 1 laboratorium.',
      checklist: [
        'Zadeklarujcie ruch do sąsiedniego obszaru (ew. przez motorówki, jeśli rozkaz pozwala).',
        'Policzcie premie, wybierzcie karty potajemnie, ujawnijcie jednocześnie.',
        'Usuńcie straty, ustalcie kontrolę obszaru; przy zmianie kontroli usuńcie 1 laboratorium.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Samochód nie kontroluje obszaru sam. Laboratorium nie jest Soldato, ale daje premię obronną. Neutralnych też można atakować — kartę za nich wybiera przeciwnik zgodnie z pomocą konfliktu.',
      commonMistake:
        'Przejmowanie obszaru samym samochodem albo pomijanie kart konfliktu przy obsadzonym celu.',
      sectionId: 'combat',
      players: [4],
    },
    {
      id: 'guided-4-9',
      title: 'Krok 9 — zamachy i symbole specjalne',
      summary:
        'Rozpatrujcie wyłącznie symbole widoczne na ujawnionym żetonie: Strike nie przejmuje obszaru; Pentito i Agitate działają tylko według nadruku. Nie inventujcie efektów z pamięci.',
      checklist: [
        'Przy Strike sprawdźcie sąsiedztwo lądowe (nie przez motorówki) i brak przejęcia kontroli.',
        'Przy Pentito / Agitate odczytajcie liczby i ograniczenia z żetonu.',
        'Jeśli tekst żetonu jest nieczytelny — obowiązuje nadruk komponentu, nie domysł.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Wiele żetonów to kombinacje symboli częściowych. Agitate nie wolno kierować w obszar sojusznika; fikcyjna rodzina z dodatku nie jest „neutralna”.',
      commonMistake:
        'Traktowanie zamachu jak przejęcia obszaru albo stosowanie Agitate na sojusznika.',
      sectionId: 'strike',
      players: [4],
    },
    {
      id: 'guided-4-10',
      title: 'Krok 10 — koniec rundy i zwycięstwo',
      summary:
        'Po starciu: usuńcie wykonane rozkazy, zaktualizujcie Mandamenti, sprawdźcie 5/6, a po 4. rundzie — liczbę Mandamenti, Bronte i ewentualny remis. Potem przygotujcie kolejne arkusze.',
      checklist: [
        'Usuńcie rozkazy z mapy po wykonaniu.',
        'Zaktualizujcie kontrolę Mandamenti i sprawdźcie natychmiastowe zwycięstwo.',
        'Po 4. rundzie rozstrzygnijcie: więcej Mandamenti → Bronte → (z poprawką) znacznik pierwszego gracza.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Zwycięstwa nie sprawdza się w środku konfliktu. Znacznik pierwszego gracza nie przechodzi automatycznie co rundę — kolejność jest stała ze strzałek.',
      commonMistake:
        'Sprawdzanie zwycięstwa przed zarządzaniem albo przekazywanie „Primo Giocatore” co rundę jak w innych grach.',
      sectionId: 'game-end',
      players: [4],
    },

    // ——— 2 players (1vs1) ———
    {
      id: 'guided-2-1',
      title: 'Krok 1 — Cupola i wypieranie',
      summary:
        'Przygotuj kafle Cupoli i pokaż 12 miejsc na członków komisji. Nowy członek wypiera przy braku wolnego miejsca — wyparły wraca do zapasu właściciela.',
      checklist: [
        'Ułóżcie Cupolę zgodnie z przygotowaniem 1vs1.',
        'Pokażcie limit 12 członków.',
        'Przećwiczcie jedno wypieranie: nowy wchodzi, wyparły wraca do zapasu.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Cupola zastępuje klasyczny tor „partnera” w 1vs1: większość i kontrola Cupoli zmieniają tempo rozwoju i zwycięstwo.',
      commonMistake:
        'Traktowanie Cupoli jak zwykłego obszaru mapy albo przekraczanie 12 miejsc.',
      sectionId: 'cupola',
      players: [2],
    },
    {
      id: 'guided-2-2',
      title: 'Krok 2 — fikcyjna rodzina',
      summary:
        'Rozstawcie Soldati fikcyjnej (nieużywanej) rodziny. Bronią obszarów, nie atakują, nie są neutralni i nie podlegają Agitate.',
      checklist: [
        'Umieśćcie jednostki fikcyjnej rodziny na wskazanych obszarach.',
        'Powiedzcie wprost: to nie szarzy neutralni.',
        'Ustalcie, kto broni ich przy ataku (przeciwna strona zgodnie z zasadami trybu).',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Mylenie fikcyjnej rodziny z neutralnymi daje błędne „nawrócenia” Soldati i złe Agitate.',
      commonMistake:
        'Dawanie bonusu za neutralnych albo ruszanie fikcyjnej rodziny Agitate.',
      sectionId: 'setup-2',
      players: [2],
    },
    {
      id: 'guided-2-3',
      title: 'Krok 3 — wpływy komisji na planszy rodziny',
      summary:
        'Na wybranych polach planszy rodziny leżą wpływy komisji. Zdejmujecie najpierw górny znacznik komisji — spowalnia to odsłanianie własnych wartości.',
      checklist: [
        'Wskażcie pola z wpływami komisji.',
        'Zdejmijcie najpierw znacznik komisji, dopiero potem własne.',
        'Przypomnijcie, że zdjęte wpływy komisji nie wracają jak znaczniki akcji solo.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Komisja spowalnia rozwój obu graczy i równoważy brak partnera. Pominięcie kolejności zdejmowania odsłania zaawansowane rozkazy za wcześnie.',
      commonMistake:
        'Zdejmowanie własnego wpływu spod komisji przed górnym znacznikiem komisji.',
      sectionId: 'shared-below-4',
      players: [2],
    },
    {
      id: 'guided-2-4',
      title: 'Krok 4 — plansza solo i pola jednorazowe',
      summary:
        'Pokażcie planszę solo: dodatkowe akcje i pola jednorazowe. Każde pole wykonujcie zgodnie z ikoną; nie powtarzajcie zużytego jednorazowego efektu.',
      checklist: [
        'Połóżcie planszę solo przy obu graczach zgodnie z setupem 1vs1.',
        'Wskażcie pola jednorazowe i oznaczcie je po użyciu.',
        'Rozliczcie jedną dodatkową akcję w przykładowej turze.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Bez planszy solo 1vs1 traci oficjalną równowagę. Pola jednorazowe to nie powtarzalne akcje arkusza.',
      commonMistake:
        'Ponowne używanie tego samego pola jednorazowego w tej samej partii.',
      sectionId: 'solo-actions-1vs1',
      players: [2],
    },
    {
      id: 'guided-2-5',
      title: 'Krok 5 — Soldato własny vs członek komisji',
      summary:
        'W pierwszej rundzie pokażcie wybór źródła efektu: własny Soldato albo członek komisji, gdy zasada na to pozwala. Po wejściu do Cupoli figura działa już tylko jako członek komisji.',
      checklist: [
        'Wykonajcie efekt, który pozwala wybrać źródło jednostki.',
        'Jeśli wybrano komisję — umieśćcie członka w Cupoli.',
        'Potwierdźcie, że w Cupoli nie jest już „zwykłym Soldato na mapie”.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Ten wybór buduje większość Cupoli i przyszłe bonusy początku rundy. Błędne mieszanie ról psuje kontrolę Cupoli.',
      commonMistake:
        'Traktowanie członka w Cupoli jak Soldato nadal stojącego na obszarze mapy.',
      sectionId: 'cupola',
      players: [2],
    },
    {
      id: 'guided-2-6',
      title: 'Krok 6 — większość Cupoli na początku rundy',
      summary:
        'Na początku kolejnej rundy rozpatrzcie, kto ma większość członków w Cupoli, i zastosujcie bonus początku rundy — nie musicie wykorzystać go w pełni.',
      checklist: [
        'Policzcie członków obu stron w Cupoli.',
        'Przyznajcie bonus większości zgodnie z instrukcją trybu.',
        'Zapamiętajcie: kontrola Cupoli (znacznik) aktualizuje się w zarządzaniu, nie na początku rundy.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Większość i kontrola to dwa różne momenty. Mylenie ich daje przedwczesne Mandamento z Cupoli.',
      commonMistake:
        'Aktualizowanie znacznika kontroli Cupoli już na początku rundy zamiast w zarządzaniu.',
      sectionId: 'cupola',
      players: [2],
    },
    {
      id: 'guided-2-7',
      title: 'Krok 7 — próg 11 i kontrola Cupoli',
      summary:
        'W zarządzaniu po starciu sprawdźcie, czy strona z co najmniej 11 członkami przejmuje kontrolę Cupoli. Cupola liczy się wtedy jak Mandamento.',
      checklist: [
        'Policzcie członków po starciu.',
        'Przy progu 11 ustawcie znacznik kontroli Cupoli.',
        'Dodajcie Cupolę do liczby Mandamenti przy sprawdzeniu zwycięstwa.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Kontrola Cupoli może dać piąte Mandamento i natychmiastowe zwycięstwo w 1vs1.',
      commonMistake:
        'Liczenie Cupoli jako Mandamento bez spełnienia progu kontroli.',
      sectionId: 'cupola',
      players: [2],
    },
    {
      id: 'guided-2-8',
      title: 'Krok 8 — Cupola w punktacji',
      summary:
        'Przy sprawdzeniu końca gry policzcie kontrolowaną Cupolę jak jedno Mandamento. Próg zwycięstwa samotnego gracza to 5 Mandamenti.',
      checklist: [
        'Dodajcie kontrolowaną Cupolę do sumy Mandamenti.',
        'Sprawdźcie próg 5.',
        'Przy remisie stosujcie Bronte, potem znacznik pierwszego gracza (z poprawką).',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Bez Cupoli w punkacji 1vs1 używa się złego progu z gry 4-osobowej.',
      commonMistake:
        'Stosowanie progu drużynowego 6 Mandamenti w partii 1vs1.',
      sectionId: 'victory-2vs1',
      players: [2],
    },
    {
      id: 'guided-2-9',
      title: 'Krok 9 — zmiana Brute Force',
      summary:
        'Przypomnijcie zmianę walki 1vs1: wskazane zdanie Brute Force usuwa 1 atakującego zamiast 2. Reszta procedury konfliktu pozostaje jak w podstawie (w tym errata vs neutralnych).',
      checklist: [
        'Otwórzcie rozdział zmiany walki 1vs1.',
        'Przy pierwszym Brute Force usuńcie 1 atakującego.',
        'Nie zmieniajcie Turncoat ani innych kart poza wskazaną regułą.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Bez tej zmiany konflikty w 1vs1 są zbyt krwawe względem oficjalnej równowagi.',
      commonMistake:
        'Zmienianie wszystkich kart konfliktu „na oko” zamiast tylko wskazanego zdania Brute Force.',
      sectionId: 'combat-1vs1',
      players: [2],
    },
    {
      id: 'guided-2-10',
      title: 'Krok 10 — próg 5 Mandamenti',
      summary:
        'Domknijcie pierwszą rundę sprawdzeniem: samotny wygrywa przy 5 Mandamenti (z Cupolą, jeśli kontrolowana). Nie mieszajcie procedur z setupem 4p.',
      checklist: [
        'Policzcie Mandamenti obu graczy.',
        'Uwzględnijcie Cupolę, jeśli ktoś ją kontroluje.',
        'Przy braku zwycięzcy przygotujcie kolejną rundę według arkuszy.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'To domknięcie uczy, że 1vs1 ma własne progi i komponenty — nie „przyciętą” partię 4-osobową.',
      commonMistake:
        'Mieszanie kroków Cupoli z przygotowaniem 2vs2.',
      sectionId: 'game-end',
      players: [2],
    },

    // ——— 3 players (2vs1) ———
    {
      id: 'guided-3-1',
      title: 'Krok 1 — poziom trudności',
      summary:
        'Wybierzcie poziom średni, jeśli wszyscy mają podobne doświadczenie. Łatwy wspiera samotnego bardziej, trudny ogranicza go mocniej przez blokady — nie przez „siłę drużyny”.',
      checklist: [
        'Ustalcie, kto jest graczem samotnym, a kto dwuosobową drużyną.',
        'Wybierzcie łatwy / średni / trudny.',
        'Samotny bierze znacznik pierwszego gracza.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Poziom ustawia przewagę samotnego przez blokady na planszy solo, a nie przez zmianę zasad drużyny.',
      commonMistake:
        'Zmienianie progów zwycięstwa zamiast układu blokad przy wyborze trudności.',
      sectionId: 'setup-3',
      players: [3],
    },
    {
      id: 'guided-3-2',
      title: 'Krok 2 — blokady planszy solo',
      summary:
        'Rozmieśćcie blokady zgodnie z wybranym poziomem na planszy solo samotnego. Partnerzy drużyny nie dostają planszy solo.',
      checklist: [
        'Połóżcie planszę solo tylko przy samotnym.',
        'Ustawcie blokady według diagramu poziomu.',
        'Sprawdźcie, że drużyna ma standardowe przygotowanie partnerów.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Blokady ograniczają dodatkowe akcje samotnego. Zła obsada psuje oficjalną asymetrię 2vs1.',
      commonMistake:
        'Dawanie planszy solo także partnerom drużyny.',
      sectionId: 'setup-3',
      players: [3],
    },
    {
      id: 'guided-3-3',
      title: 'Krok 3 — dodatkowa akcja samotnego',
      summary:
        'W każdej swojej turze samotny wykonuje dodatkową akcję z planszy solo oraz zwykłą akcję arkusza. Rozliczcie jedną akcję w całości przed następną.',
      checklist: [
        'Wskażcie ikony dodatkowej akcji na planszy solo.',
        'Wykonajcie przykładową turę: dodatkowa + normalna.',
        'Nie wykonujcie dodatkowej akcji przy Ultima Azione.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Dodatkowa akcja rekompensuje brak partnera. Ultima Azione jest wyjątkiem — bez dodatkowej akcji.',
      commonMistake:
        'Wykonywanie dodatkowej akcji także przy Ultima Azione.',
      sectionId: 'extra-actions-3',
      players: [3],
    },
    {
      id: 'guided-3-4',
      title: 'Krok 4 — jednorazowe wpływy komisji',
      summary:
        'Pokażcie, które wpływy komisji na planszy rodziny są jednorazowe i muszą zejść przed własnymi znacznikami na podwójnych polach.',
      checklist: [
        'Wskażcie pięć podwójnych pól z komisją.',
        'Zdejmijcie najpierw znacznik komisji.',
        'Potwierdźcie, że nie wracają jak dodatkowe znaczniki akcji na koniec rundy.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Komisja spowalnia rozwój i jest wspólna dla trybów poniżej 4 graczy. Pomylenie z resetem znaczników akcji psuje ekonomię.',
      commonMistake:
        'Resetowanie wpływów komisji razem z dodatkowymi znacznikami akcji na koniec rundy.',
      sectionId: 'shared-below-4',
      players: [3],
    },
    {
      id: 'guided-3-5',
      title: 'Krok 5 — ograniczenie kolumny drużyny',
      summary:
        'Po turze pierwszego członka drużyny oznaczcie kolumnę, z której wziął wpływ. Drugi partner nie może w następnej turze drużyny opróżnić tej samej kolumny.',
      checklist: [
        'Partner A bierze wpływ z wybranej kolumny.',
        'Oznaczcie tę kolumnę znacznikiem ograniczenia.',
        'Partner B w kolejnej turze drużyny omija tę kolumnę.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Reguła chroni przed zbyt łatwym opróżnianiem jednej kolumny przez dwuosobową stronę.',
      commonMistake:
        'Stosowanie ograniczenia także do samotnego albo trzymanie go przez całą rundę wbrew kolejności tur.',
      sectionId: 'player-order-3',
      players: [3],
    },
    {
      id: 'guided-3-6',
      title: 'Krok 6 — Ultima Azione bez dodatku',
      summary:
        'Gdy zostanie Ultima Azione, samotny nie wykonuje dodatkowej akcji z planszy solo — tylko procedurę Ultima Azione jak w zasadach podstawowych.',
      checklist: [
        'Doprowadźcie arkusz do sytuacji Ultima Azione.',
        'Samotny pomija dodatkową akcję solo.',
        'Wykonajcie Ultima Azione zgodnie z rozdziałem podstawowym.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'To częsty błąd przy pierwszej partii 2vs1: „dopychanie” ekstra akcji w momencie specjalnego zakończenia planowania.',
      commonMistake:
        'Dokładanie dodatkowej akcji solo do Ultima Azione.',
      sectionId: 'ultima-azione',
      players: [3],
    },
    {
      id: 'guided-3-7',
      title: 'Krok 7 — reset dodatkowych znaczników',
      summary:
        'Na końcu rundy zresetujcie dodatkowe znaczniki akcji samotnego zgodnie z instrukcją. Wpływów zdjętych z planszy rodziny / komisji nie przywracajcie jak tych znaczników.',
      checklist: [
        'Zidentyfikujcie dodatkowe znaczniki akcji na planszy solo.',
        'Przywróćcie je na pozycje startowe rundy.',
        'Pozostawcie zdjęte wpływy komisji usunięte.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Bez resetu samotny traci lub zyskuje nielegalne akcje w kolejnej rundzie.',
      commonMistake:
        'Mieszanie resetu znaczników akcji z wpływami komisji na planszy rodziny.',
      sectionId: 'extra-fields-3',
      players: [3],
    },
    {
      id: 'guided-3-8',
      title: 'Krok 8 — odblokowanie kolejnego pola',
      summary:
        'Odblokujcie jedno kolejne pole planszy solo zgodnie z zasadą blokad poziomu trudności — nie zdejmujcie wszystkich blokad naraz.',
      checklist: [
        'Sprawdźcie diagram odblokowań dla waszego poziomu.',
        'Zdejmijcie dokładnie jedną kolejną blokadę (lub zgodnie z dokładnym tekstem poziomu).',
        'Potwierdźcie nowo dostępne pole dodatkowej akcji.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Stopniowe odblokowanie utrzymuje krzywą trudności przez cztery rundy.',
      commonMistake:
        'Zdejmowanie wszystkich blokad po pierwszej rundzie.',
      sectionId: 'extra-fields-3',
      players: [3],
    },
    {
      id: 'guided-3-9',
      title: 'Krok 9 — różne progi stron',
      summary:
        'Samotny wygrywa przy 5 Mandamenti; dwuosobowa drużyna przy 6 łącznie albo 5 u jednego partnera. Najpierw porównujcie liczby Mandamenti.',
      checklist: [
        'Policzcie Mandamenti samotnego i drużyny osobno.',
        'Zastosujcie właściwy próg dla każdej strony.',
        'Przy równoczesnym spełnieniu porównajcie liczby Mandamenti.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Jedna tabela zwycięstwa dla obu stron prowadzi do fałszywych remisów i „dokładek”.',
      commonMistake:
        'Stosowanie tego samego progu 6 dla samotnego i drużyny.',
      sectionId: 'victory-2vs1',
      players: [3],
    },
    {
      id: 'guided-3-10',
      title: 'Krok 10 — remis i pierwszy gracz',
      summary:
        'Przy remisie po Mandamenti sprawdźcie Bronte, a potem znacznik pierwszego gracza (startowo u samotnego). To oficjalne domknięcie z poprawką dodatku.',
      checklist: [
        'Porównajcie liczbę Mandamenti.',
        'Przy remisie sprawdźcie kontrolę Bronte.',
        'Jeśli nadal remis — wygrywa posiadacz znacznika pierwszego gracza.',
      ],
      whyTitle: 'Dlaczego to ważne',
      whyContent:
        'Bez tej drabinki remisowej partia 2vs1 kończy się niejednoznacznie mimo oficjalnych zasad dodatku.',
      commonMistake:
        'Ogłaszanie remisu bez sprawdzenia Bronte i znacznika pierwszego gracza.',
      sectionId: 'game-end',
      players: [3],
    },
  ],
};
